<template>
    <div>
        <div v-html='content'></div>

        <div class='resourceTiles'>
        <bundle-tile v-for='bundle in bundles' :key='bundle.slug' :bundle='bundle' :slug='bundle.slug'></bundle-tile>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EducationBundleTile from '../../components/EducationBundleTile';

export default {
    data() {
        return {
            bundles: [],
            content: ''
        }
    },
    methods: {
        update() {
            axios.get(`${this.$api}/education/bundles`).then((response) => {
                this.bundles = response.data;
            });

            axios.get(`${window.location.href}content`).then((result) => {
                this.content = result.data.content;
            });
        }
    },
    created() {
        this.update();
    },
    components: {
        'bundle-tile': EducationBundleTile
    }
}
</script>